import { DisplayType } from "./DisplayType";


export default class DisplayTypeSet {
    types: Array<DisplayType>;

    constructor() {
        this.types = new Array<DisplayType>();
    }

    clearTypes() {
        this.types = new Array<DisplayType>();
    }

    addType(config: DisplayType) {
        this.types.push(config);
    }

    removeType(config: DisplayType | string) {
        if (typeof config === "string")
            config = this.types.find(item => item.type === config);

        if (this.types.includes(config))
            this.types.splice(this.types.indexOf(config), 1);
    }
}